import { useTranslation } from 'react-i18next';
import './Capabilities.css';

const PILLARS = ['software', 'automation', 'ai'] as const;

export function Capabilities() {
  const { t } = useTranslation();

  return (
    <section id="capabilities" className="section">
      <div className="container">
        <div className="section-header">
          <span className="eyebrow">{t('capabilities.eyebrow')}</span>
          <h2>{t('capabilities.title')}</h2>
          <p>{t('capabilities.subtitle')}</p>
        </div>

        <div className="pillars-grid">
          {PILLARS.map((key, i) => (
            <article key={key} className="pillar-card">
              <span className="pillar-card__num" aria-hidden="true">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="pillar-card__title">{t(`capabilities.items.${key}.title`)}</h3>
              <p className="pillar-card__body">{t(`capabilities.items.${key}.body`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
